import { useTenant } from "@/providers/session";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { noop } from "lodash";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

export const useDeleteWhatsAppForwarding = () => {
  const { t } = useTranslation();
  const { tenantId } = useTenant();
  const [deleteWhatsAppForwarding, { data, loading, error }] = useMutation(
    DELETE_WHATSAPP_FORWARDING_MUTATION,
    {
      optimisticResponse: {
        deleteWhatsAppForwarding: true,
      },
      update: (
        cache,
        { data: { deleteWhatsAppForwarding } },
        { variables },
      ) => {
        if (deleteWhatsAppForwarding) {
          const { whatsappForwardingId } = variables as any;

          cache.modify({
            fields: {
              whatsappForwardings(
                existingWhatsAppForwardings = [],
                { readField },
              ) {
                return existingWhatsAppForwardings.filter(
                  (forwarding: any) =>
                    readField("whatsappForwardingId", forwarding) !==
                    whatsappForwardingId,
                );
              },
            },
          });
        }
      },
    },
  );

  const handleDeleteWhatsAppForwarding = async (
    whatsappForwardingId: string,
    onSuccess: () => void = noop,
    onError: () => void = noop,
  ) => {
    if (!tenantId) {
      throw new Error("Tenant ID is required");
    }

    await toast.promise(
      deleteWhatsAppForwarding({
        variables: {
          whatsappForwardingId,
        },
      }),
      {
        loading: t("generic_loading"),
        success: () => {
          onSuccess();
          return t("generic_success");
        },
        error: () => {
          onError();
          return t("generic_error", { richColors: true });
        },
      },
    );
  };

  return {
    deleteWhatsAppForwarding: handleDeleteWhatsAppForwarding,
    data: data?.deleteWhatsAppForwarding,
    loading,
    error,
  };
};

export const DELETE_WHATSAPP_FORWARDING_MUTATION = gql`
  mutation DeleteWhatsAppForwarding($whatsappForwardingId: String!) {
    deleteWhatsAppForwarding(whatsappForwardingId: $whatsappForwardingId)
  }
`;
